import * as angular from "angular";
import {IController} from "angular";

export class PasswordMeterComponent implements IController {
  form: any;
  password: any;
  passwordPolicy: any;
  isShowPassword: any;
  extras: string[];
  onChange: Function;

  strength: any = {};
  type: any = undefined;

  constructor() {
  }

  $onInit() {
    this.strength = {
      0: "Bad",
      1: "Low",
      2: "Fair",
      3: "Good",
      4: "Excellent"
    };

    this.type = !!this.isShowPassword ? 'text' : 'password';

  };

  $onChanges(changes) {
    if (changes.isShowPassword && !changes.isShowPassword.isFirstChange()) {
      this.type = !!this.isShowPassword ? 'text' : 'password';
    }
  };

}

angular
  .module('bringoz.admin.commons')
  .component('passwordMeter', {
    require: {
      form: '^form'
    },
    bindings: {
      password: '<',
      passwordPolicy: '<?',
      onChange: '&',
      isShowPassword: '<?',
      extras: '<?'
    },
    templateUrl: 'app/modules/commons/components/password-meter/password-meter.html',
    controller: PasswordMeterComponent
  });

